export default __webpack_public_path__ + "static/media/csv-invalid-row.7acc328e.svg";